export * from './post-bericht.service';
export * from './post-bericht.service.module';